import React from 'react';
import { isWeekend } from 'web-platform-alpha/libs/date';
import { useDateFormatter } from 'web-platform-alpha';
import { cnCalendar } from '../Calendar.const';
import { Grid, GridCell, GridRow, GridSection } from '../shared';
// TODO: May be move to web-platform?
var visuallyHiddenStyle = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    margin: '0 -1px -1px 0',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1,
    whiteSpace: 'nowrap',
};
export var DaysOfWeek = function (props) {
    var showWeekNumbers = props.showWeekNumbers, daysOfWeek = props.daysOfWeek;
    var shortFormatter = useDateFormatter({ weekday: 'short' });
    var longFormatter = useDateFormatter({ weekday: 'long' });
    return (React.createElement(Grid, { className: cnCalendar('DaysOfWeek') },
        showWeekNumbers && (React.createElement(GridSection, { type: "aside" },
            React.createElement(GridRow, null,
                React.createElement(GridCell, null)))),
        React.createElement(GridSection, { type: "body" },
            React.createElement(GridRow, null, daysOfWeek.map(function (dayOfWeek, index) { return (React.createElement(GridCell, { key: index },
                React.createElement("span", { style: visuallyHiddenStyle }, longFormatter.format(dayOfWeek)),
                React.createElement("span", { className: cnCalendar('DayOfWeek', { weekend: isWeekend(dayOfWeek) }), "aria-hidden": true }, shortFormatter.format(dayOfWeek)))); })))));
};
